<template>
  <section
    :style="paddingCalculator"
    :class="$store.getters['main/getBackgroundTone'](evenOdd)"
  >
    <div class="info-image container">
      <div class="info-image__content">
        <div class="info-image__title font-38 ">
          {{ _.get(contentData, "data.list[0].title") }}
        </div>
        <div
          class="content-section"
          v-for="(tab, indx) in _.get(contentData, 'data.list[0].content.tabs')"
          :key="indx"
        >
          <div class="content-section__title font-18 tbc-bold">
            {{ _.get(tab, "title") }}
          </div>
          <div
            class="content-section__teaser font-16 lh-21 tbc-regular"
            v-html="_.get(tab, 'content')"
          ></div>
        </div>
        <div
          class="info-image__teaser"
          v-if="_.get(contentData, 'data.list[0].teaser')"
        >
          * {{ _.get(contentData, "data.list[0].teaser") }}
        </div>
        <div
          class="view-more animated-link animated-link-a flex-box al-center"
          v-if="_.get(contentData, 'data.list[0].moreLink.title')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
          >
            <path
              id="Combined_Shape_Copy_2"
              data-name="Combined Shape Copy 2"
              d="M6.175,13.658a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.658a1.167,1.167,0,0,1-1.65,0Z"
              transform="translate(0 0)"
              fill="#00aeef"
            />
          </svg>

          <a
            class="flex-box uppercase"
            target="_blank"
            :href="_.get(contentData, 'data.list[0].moreLink.url')"
          >
            {{ _.get(contentData, "data.list[0].moreLink.title") }}
          </a>
        </div>
      </div>
      <div class="info-image__img relative br-4">
        <picture>
          <source
            media="(max-width: 767px)"
            :srcset="
              _.get(contentData, 'data.list[0].images[0].devices.mobile')
            "
            class="img-absolute"
          />
          <source
            media="(max-width: 1023px)"
            :srcset="
              _.get(contentData, 'data.list[0].images[0].devices.tablet')
            "
            class="img-absolute"
          />
          <img
            :src="_.get(contentData, 'data.list[0].images[0].devices.desktop')"
            class="img-absolute br-4"
            loading="lazy"
            alt
          />
        </picture>
      </div>
    </div>
  </section>
</template>

<script>
import paddingCalculator from "@/mixins/paddingMixin";

export default {
  mixins: [paddingCalculator],
  props: ["contentData", "evenOdd"],
  data() {
    return {
      pTopDesktop: 89,
      pBottomDesktop: 89,

      pBottomTablet: 89,
      pBottomMobile: 89
    };
  }
};
</script>

<style lang="scss" scoped>
.info-image {
  display: flex;
  justify-content: space-between;
  @media (max-width: 1023px) {
    flex-direction: column-reverse;
  }
  &__title {
    margin-bottom: 36px;

    @media (max-width: 1023px) {
      font-size: 24px;
      margin-bottom: 41px;
    }
  }
  &__img {
    width: 540px;
    height: 483px;
    @media (max-width: 1399px) {
      width: 450px;
    }
    @media (max-width: 1023px) {
      width: 100%;
      margin-bottom: 34px;
    }
    @media (max-width: 767px) {
      height: 233px;
    }
    @media (max-width: 414px) {
      height: 175px;
    }
  }
  &__content {
    display: flex;
    flex-direction: column;
    max-width: 58%;
    @media (max-width: 1023px) {
      max-width: unset;
    }
    .view-more {
      margin-top: auto;
    }
    .content-section {
      margin-bottom: 27px;
      max-width: 90%;
      @media (max-width: 1023px) {
        max-width: unset;
      }

      &__title {
        margin-bottom: 8px;
      }
      &__teaser {
        // max-width: 350px;
        // /deep/ p {
        //   font-family: inherit;
        // }
      }
    }
  }
  &__teaser {
    font-size: 12px;
  }
}
</style>
